import * as React from "react"

const base = {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
}

export const PlayIcon = () => (
  <svg {...base} aria-hidden="true">
    <path d="M4 2.5v11l10-5.5-10-5.5z" fill="currentColor" />
  </svg>
)

export const PlusIcon = () => (
  <svg {...base} aria-hidden="true">
    <path d="M8 3v10M3 8h10" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
  </svg>
)

export const ArrowRightIcon = () => (
  <svg {...base} aria-hidden="true">
    <path d="M3 8h9.5M8.5 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const GripIcon = () => (
  <svg {...base} aria-hidden="true">
    <circle cx="5.5" cy="4.5" r="1.15" fill="currentColor" />
    <circle cx="10.5" cy="4.5" r="1.15" fill="currentColor" />
    <circle cx="5.5" cy="8" r="1.15" fill="currentColor" />
    <circle cx="10.5" cy="8" r="1.15" fill="currentColor" />
    <circle cx="5.5" cy="11.5" r="1.15" fill="currentColor" />
    <circle cx="10.5" cy="11.5" r="1.15" fill="currentColor" />
  </svg>
)

export const TrashIcon = () => (
  <svg {...base} aria-hidden="true">
    <path
      d="M3 4.5h10M6.5 4.5V3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1.5M4.5 4.5l.6 8.1a1 1 0 0 0 1 .9h3.8a1 1 0 0 0 1-.9l.6-8.1"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path d="M6.5 7v4M9.5 7v4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
)

export const MessageIcon = () => (
  <svg {...base} aria-hidden="true">
    <path
      d="M2 3h12v7H6.5L3 13v-3H2z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
)

export const PointerIcon = () => (
  <svg {...base} aria-hidden="true">
    <path
      d="M4 3l8 4.5-3.5 1-1.5 4.5L4 3z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
      fill="currentColor"
    />
  </svg>
)

export const VideoPointerIcon = () => (
  <svg {...base} aria-hidden="true">
    <rect x="1.5" y="3" width="13" height="10" rx="2" stroke="currentColor" strokeWidth="1.3" fill="none" />
    <path d="M6.5 6l4 2.5-4 2.5z" fill="currentColor" />
  </svg>
)

export const ChevronDownIcon = () => (
  <svg {...base} aria-hidden="true">
    <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const KeyboardIcon = () => (
  <svg {...base} aria-hidden="true">
    <rect x="1.5" y="3.5" width="13" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.25" />
    <path
      d="M4 6.25h.01M6.5 6.25h.01M9 6.25h.01M11.5 6.25h.01M4 8.75h.01M6.5 8.75h3M11.5 8.75h.01"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
)
